// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.diagnostic-tools {
  padding: 10px;
  max-width: 1200px;
  margin: auto;
}

.tool-title {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
}

.tool-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.tool-card {
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.tool-card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.bg-maclookup {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: #fff;
  font-weight: 600;
  box-shadow: 0 3px 10px rgba(37, 117, 252, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.bg-maclookup:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(37, 117, 252, 0.4);
}

/* Individual Tool Colors */
.bg-ping {
  background-color: #2196f3; /* Blue */
}

.bg-traceroute {
  background-color: #4caf50; /* Green */
}

.bg-speedtest {
  background-color: #fbc02d; /* Yellow */
}

.bg-portscan {
  background-color: #9c27b0; /* Deep Purple */
}

.bg-dnslookup {
  background-color: #ff7043; /* Orange */
}

.bg-ipinfo {
  background-color: #26a69a; /* Teal */
}

/* Output box */
.selected-tool-output {
  margin-top: 20px;
  padding: 20px;
  background-color: #f3f3f3;
  border-radius: 10px;
  min-height: 200px;
}

.bg-playlist {
  background: linear-gradient(135deg, #00b09b, #96c93d); /* সুন্দর গ্রিন গ্রেডিয়েন্ট */
  color: white;
}

.channel-item {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 5px;
  border-radius: 8px;
  cursor: pointer;
  background: #f8f9fa;
  transition: 0.3s;
}

.channel-item:hover {
  background: #e9ecef;
}

.copy-hint {
  margin-left: auto;
  color: #888;
  font-size: 10px;
}

.bg-terminal {
  background: #111827;
  color: #00ff88;
  font-weight: bold;
}

/* নতুন ৩টি টুল কার্ডের জন্য কালার ও স্টাইল */
.bg-subnet {
  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
  color: #f3f4f6;
  font-weight: 600;
  border: 1px solid #4b5563;
}

.bg-whois {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  color: #fff;
  font-weight: 600;
}

.bg-lanscan {
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  color: #fff;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/DiagnosticTools.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB,EAAE,SAAS;AACtC;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,yBAAyB,EAAE,WAAW;AACxC;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,WAAW;AACxC;;AAEA;EACE,yBAAyB,EAAE,SAAS;AACtC;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD,EAAE,8BAA8B;EACrF,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".diagnostic-tools {\n  padding: 10px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.tool-title {\n  text-align: center;\n  font-size: 28px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.tool-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.tool-card {\n  padding: 20px;\n  border-radius: 12px;\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.tool-card:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.bg-maclookup {\n  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  color: #fff;\n  font-weight: 600;\n  box-shadow: 0 3px 10px rgba(37, 117, 252, 0.3);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.bg-maclookup:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 5px 15px rgba(37, 117, 252, 0.4);\n}\n\n/* Individual Tool Colors */\n.bg-ping {\n  background-color: #2196f3; /* Blue */\n}\n\n.bg-traceroute {\n  background-color: #4caf50; /* Green */\n}\n\n.bg-speedtest {\n  background-color: #fbc02d; /* Yellow */\n}\n\n.bg-portscan {\n  background-color: #9c27b0; /* Deep Purple */\n}\n\n.bg-dnslookup {\n  background-color: #ff7043; /* Orange */\n}\n\n.bg-ipinfo {\n  background-color: #26a69a; /* Teal */\n}\n\n/* Output box */\n.selected-tool-output {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f3f3f3;\n  border-radius: 10px;\n  min-height: 200px;\n}\n\n.bg-playlist {\n  background: linear-gradient(135deg, #00b09b, #96c93d); /* সুন্দর গ্রিন গ্রেডিয়েন্ট */\n  color: white;\n}\n\n.channel-item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  margin-bottom: 5px;\n  border-radius: 8px;\n  cursor: pointer;\n  background: #f8f9fa;\n  transition: 0.3s;\n}\n\n.channel-item:hover {\n  background: #e9ecef;\n}\n\n.copy-hint {\n  margin-left: auto;\n  color: #888;\n  font-size: 10px;\n}\n\n.bg-terminal {\n  background: #111827;\n  color: #00ff88;\n  font-weight: bold;\n}\n\n/* নতুন ৩টি টুল কার্ডের জন্য কালার ও স্টাইল */\n.bg-subnet {\n  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);\n  color: #f3f4f6;\n  font-weight: 600;\n  border: 1px solid #4b5563;\n}\n\n.bg-whois {\n  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);\n  color: #fff;\n  font-weight: 600;\n}\n\n.bg-lanscan {\n  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);\n  color: #fff;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
